import { loggerError } from "./logger";

// 创建一个<a>元素并设置它的href属性
const aElement = document.createElement('a');

export function resolveUrl(href: string) {
    aElement.href = href;
    return aElement.href;
}

export function getUrlObj(url: string) {
    try {
        return new URL(url);
    } catch (err) {
        loggerError(err);
        return null;
    }
}

